module.exports = __webpack_public_path__ + "media/images/socials/chessdotcom-336a68458a6375a44a0d18af55fc5c2f.png";